<template>
  <div v-loading="submitLoading" class="adminAdd">
    <div class="adminForm">
      <div class="subTitle">
        添加管理员
      </div>
      <div class="formAdd">
        <el-form ref="form" :model="form" label-width="150px">
          <el-form-item label="真实姓名：" required>
            <el-input
              v-model="form.userName"
              placeholder="请输入管理员姓名"
              class="inputlabel"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="登录手机号：" required>
            <el-input
              v-model="form.phone"
              placeholder="请设置登录手机号"
              class="inputlabel"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="登录密码：" required>
            <el-input
              v-model="form.password"
              placeholder="请设置登录密码"
              class="inputlabel"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号码：" required>
            <el-input
              v-model="form.idCard"
              placeholder="请输入管理员身份证号"
              class="inputlabel"
              clearable
            ></el-input>
            <el-form-item>
              <div class="btnItem">
                <el-button @click="handleSubmit">保存</el-button>
              </div>
            </el-form-item>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { adminNewAdd } from '@/api/system'
import to from 'await-to'
export default {
  data() {
    return {
      form: {},
      submitLoading: false,
    }
  },
  methods: {
    async handleSubmit() {
      if (!this.form.userName) return this.$message.warning('管理员姓名不能为空!')
      if (!this.form.phone) return this.$message.warning('请设置管理员登录手机号!')
      if (!this.form.password) return this.$message.warning('请设置登录密码')
      if (!this.form.idCard) return this.$message.warning('管理员身份证号不能为空!')
      this.submitLoading = true
      const [, err] = await to(adminNewAdd({ ...this.form }))
      this.submitLoading = false
      if (err) return this.$message.warning(err.msg)
      this.$message({ message: '保存成功', type: 'success' })
      this.$router.push({ path: '/system/admin' })
    },
  },
}
</script>
<style lang="scss" scoped>
.adminAdd {
  width: 100%;
  height: 100%;
  padding-bottom: 12px;
  .adminForm {
    height: 100%;
    background: #ffffff;
    .subTitle {
      height: 72px;
      border-bottom: 1px solid #e8ebf2;
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      line-height: 72px;
      padding-left: 20px;
    }
    .formAdd {
      margin-top: 30px;
      .inputlabel {
        width: 440px;
        height: 40px;
        background: #ffffff;
        border-radius: 2px 2px 2px 2px;
        ::v-deep .el-input__inner {
          height: 40px;
          line-height: 40px;
        }
      }
      .btnItem {
        margin-top: 50px;
        ::v-deep .el-button {
          width: 100px;
          height: 40px;
          background: #3671bf;
          border-radius: 4px 4px 4px 4px;
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
